import type {Resolver} from "../../../../../sdo/Resolver.ts";
import AddressPartEditor from "./editors/AddressPartEditor.tsx";
import CharacterEditor from "./editors/CharacterEditor.tsx";
import FieldEditor from "./editors/FieldEditor.tsx";
import GeoFenceEditor from "./editors/GeoFenceEditor.tsx";
import HashEditor from "./editors/HashEditor.tsx";
import IntelligenceEditor from "./editors/IntelligenceEditor.tsx";
import MeasurementEditor from "./editors/MeasurementEditor.tsx";
import NamePartEditor from "./editors/NamePartEditor.tsx";
import NumericEditor from "./editors/NumericEditor.tsx";
import RegExEditor from "./editors/RegExEditor.tsx";
import TemporalEditor from "./editors/TemporalEditor.tsx";
import WordEditor from "./editors/WordEditor.tsx";

interface ResolverEditorProps {
    draft: Resolver;
    editing: boolean;
    onChange: (updated: Resolver) => void;
}

function ResolverEditor({draft, editing, onChange}: ResolverEditorProps) {
    switch (draft.type) {
        case 'ADDRESS_PART': return <AddressPartEditor draft={draft} editing={editing} onChange={onChange}/>;
        case 'CHARACTER':    return <CharacterEditor draft={draft} editing={editing} onChange={onChange}/>;
        case 'FIELD':        return <FieldEditor draft={draft} editing={editing} onChange={onChange}/>;
        case 'GEOFENCE':     return <GeoFenceEditor draft={draft} editing={editing} onChange={onChange}/>;
        case 'HASH':         return <HashEditor draft={draft} editing={editing} onChange={onChange}/>;
        case 'INTELLIGENCE': return <IntelligenceEditor draft={draft} editing={editing} onChange={onChange}/>;
        case 'MEASUREMENT':  return <MeasurementEditor draft={draft} editing={editing} onChange={onChange}/>;
        case 'NAME_PART':    return <NamePartEditor draft={draft} editing={editing} onChange={onChange}/>;
        case 'NUMERIC':      return <NumericEditor draft={draft} editing={editing} onChange={onChange}/>;
        case 'REGEX':        return <RegExEditor draft={draft} editing={editing} onChange={onChange}/>;
        case 'TEMPORAL':     return <TemporalEditor draft={draft} editing={editing} onChange={onChange}/>;
        case 'WORD':         return <WordEditor draft={draft} editing={editing} onChange={onChange}/>;
    }
}

export default ResolverEditor;
